import * as React from 'react';
import { Popover } from '../../../../popover';
import * as styles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export function SliderValueLabelPopover(props) {
  return /*#__PURE__*/_jsx(Popover, {
    open: props.open,
    placement: "top",
    preventOverflow: true,
    content: /*#__PURE__*/_jsx("div", {
      className: styles['tooltip'],
      children: props.label
    }),
    children: props.children
  });
}